export default __webpack_public_path__ + "static/media/Mais.a2c0279a.svg";